import { Selector } from "@com.mgmtp.a12.client/client-core/lib/core/store";
import { ModelSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/model";
import { Model as ModelApi } from "@com.mgmtp.a12.base/base-model-api/lib/main/model/internal/model";

export function modelLoadedInScene(criteria: ModelSearchDescriptor): Selector<ModelLoadedResult> {
	return state => {
		const model = ModelSelectors.modelInScene(criteria)(state);
		if (model === undefined) {
			const error = ModelSelectors.modelErrorInScene(criteria)(state);
			return { stateChanged: error !== undefined, returnValue: undefined };
		}

		return { stateChanged: true, returnValue: model };
	};
}

interface ModelLoadedResult {
	readonly stateChanged: boolean;
	readonly returnValue: ModelApi | undefined;
}

interface ModelSearchDescriptor {
	readonly activityId: string;
	readonly modelType: string;
	readonly dataModel?: string;
}
